// Shim for Faye - provides `global` polyfill needed by Faye's source
if (typeof global === 'undefined') {
  window.global = globalThis
}

const Faye = await import('faye/src/faye_browser')
export default Faye.default
